import _ from 'lodash';
import React, { Component } from 'react';
import { inject } from 'mobx-react';

import SongRow from './song-row';

@inject('songsStore')
class SongList extends Component {
	render () {
		const { songsStore, songList } = this.props;

		if (_.isEmpty(songList)) {

			return null;
		}

		return (
			<div className="song-list">
				<div className="grid-x align-justify align-middle song-header-row">
					<div className="cell auto">
						<div className="song-header-counter">#</div>
					</div>
					<div className="cell small-4">
						<strong>Title</strong>
					</div>

					<div className="cell small-3">
						<strong>Artist</strong>
					</div>

					<div className="cell small-2">
						<strong>Genre</strong>
					</div>

					<div className="cell small-1 text-center">
						<strong>Duration</strong>
					</div>
				</div>

				{
					songList.map(
						(song, index) =>
							<SongRow
								key={ song._id }
								index={ index }
								song={ song }
								songID={ song._id }
								songsStore={ songsStore }
							/>
					)
				}
			</div>
		);
	}
}

export default SongList;
